import { GetCryptoCurrencyListResponse } from "@services/models/Transactions/GetCryptoCurrencyListModel";
import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";

class SettleAccountApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient();
  }

  public async settleAccounts(data: any): Promise<any> {
    try {
      const response = await this.api.post("/adminPanel/settleAccounts", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getCryptoCurrencyList(): Promise<GetCryptoCurrencyListResponse> {
    try {
      const response = await this.api.get<GetCryptoCurrencyListResponse>(
        "/p2p/getCryptoCurrencyList"
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const settleAccountApiServices = new SettleAccountApiService();
